import React    from 'react'
import selectn  from 'selectn'

const EVENT_ICON_CODE   = { 1: 'T', 2: '&#xE09F;', 3: '&#xE0A0;', 4: '&#xE097;', 5: '', 6: '' }
const EVENT_ICON_ORDER  = [ 1,2,3,4,5,6 ]
const FIXED_WIDTH = { width:'33px' }
const PlayerList = ({
  name        = '-',
  logo        = '',
  team        = [],
  reserves    = [],
  text        = {},
  matchState  = ''
}) => {

  /*
  if(aPlayerList.home.team.length <= 0){
    aPlayerList.home.team.push((
      <tr key="noHome">
        <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
      </tr>
    ));
  }

  if(aPlayerList.away.team.length <= 0){
    aPlayerList.away.team.push((
      <tr key="noAway">
        <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
      </tr>
    ));
  }
  */
  
  return (
    <table data-behavior="table_accordion" className="table-accordion">
      <caption>
        {
          logo && <img src={logo} />
        }
        {name}
      </caption>
      <thead>
        {
          matchState === 'pregame' ?
            (
              <tr>
                <th className="number" style={ FIXED_WIDTH }>{ text.col2 || '-' }</th>
                <th className="name" colSpan="2">{ text.col3 || '-' }</th>
              </tr>
            ):(
              <tr>
                <th style={ FIXED_WIDTH }></th>
                <th className="number">{ text.col2 || '-' }</th>
                <th className="name">{ text.col3 || '-' }</th>
              </tr>
            )
        }
      </thead>
      <tbody>
        {
          team.map((p, i) => {
            return <PlayerListRow key={i} {...p} text={text} matchState={matchState} />
          })
        }
      </tbody>
      <thead>
        <tr className="secondTableHeader">
          <th colSpan="3">{ text.split || '-' }</th>
        </tr>
      </thead>
      <tbody>
        {
          reserves.map((p, i) => {
            return <PlayerListRow key={i} {...p} text={text} matchState={matchState} />
          })
        }
      </tbody>
    </table>
  )
  
}

const ExpandedStats = ({
  tackles         = {},
  missedtackles   = {},
  tries           = {},
  runs            = {},
  metres          = {}
}) => {

  const iTotalTackles = parseInt(tackles.value)+parseInt(missedtackles.value)
  const iTacklesPerc  = parseInt((tackles.value/iTotalTackles)*100)
  const iMissedPerc   = parseInt((missedtackles.value/iTotalTackles)*100)
  
  return (
    <div className="accordion-content open">
      <div className="lineup-stats">
        <ul className="stats">
          <li className="stat">
            <span className="label">{tries.name}</span>
            <span className="value">{tries.value}</span>
          </li>
          <li className="stat">
            <span className="label">{runs.name}</span>
            <span className="value">{runs.value}</span>
          </li>
          <li className="stat">
            <span className="label">{metres.name}</span>
            <span className="value">{metres.value}</span>
          </li>
        </ul>
        <div className="fouls">
          <ul className="compareLineGraph sameTeam">
            <li>
              <span className="chartLabel">{tackles.name}</span>
              <span style={ { backgroundColor:'#f2f2f2' } } className="bar-total">
                <span style={ { backgroundColor:'#dd2126', width:iTacklesPerc+'%' } } className="bar-percentage"></span>
              </span>
              <span className="chartValue">{tackles.value}</span>
            </li>
            <li>
              <span style={ { backgroundColor:'#f2f2f2' } } className="bar-total">
                <span style={ { backgroundColor:'#dd2126', width:iMissedPerc+'%' } } className="bar-percentage"></span>
              </span>
              <span className="chartValue">{missedtackles.value}</span>
              <span className="chartLabel">{missedtackles.name}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

class PlayerListRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      expanded :  false
    }
  }

  expandRow() {
    if ( this.state.expanded ) {
      this.setState( { expanded: false } )
    }else{
      this.setState( { expanded: true } )
    }
  }

  render() {

    if ( this.props.matchState === 'pregame' ) {
      return (
        <tr>
          <td className="number">{this.props.number || '-'}</td>
          <td colSpan="2" className="date">{(this.props.name || '-')+', '+(this.props.position || '-')+' '}</td>
        </tr>
      )
    }else{

      let aIcons = []
      for ( let iEventType of EVENT_ICON_ORDER ) {
        if ( typeof this.props.eventTimes[iEventType] !== 'undefined' ) {

          let iQuant = this.props.eventTimes[iEventType].length
          let sClassStr = 'icon-font rugby-icon'
          if ( iEventType == 5 ) {
            sClassStr = 'game-icon icon-font-before icon-soccer-card02-solid-before icon-yellowcard'
          }else if ( iEventType == 6 ) {
            sClassStr = 'game-icon icon-font-before icon-soccer-card02-solid-before icon-redcard'
          }

          aIcons.push((
            <div key={'icon.'+iEventType} className="tooltip" data-tooltip={'('+this.props.eventTimes[iEventType].join(',')+')'}><span className={sClassStr} dangerouslySetInnerHTML={ { __html:EVENT_ICON_CODE[iEventType] } }></span></div>
          ))
          if ( iQuant > 1 ) {
            aIcons.push((
              <span key={'icon.sub.'+iEventType} className="subscript">{iQuant}</span>
            ))
          }
        }
      }
  
      return (
        <tr className={this.state.expanded ? 'active' : null}>
          <td colSpan="3" className={this.state.expanded ? 'active' : null}>
            <div className="accordion-item ">
              <div className="accordion-header lineup-player" onClick={ this.props.wasActive ? this.expandRow.bind(this) : '' }>
                {
                  this.props.wasActive &&
                  <span key="btn" className={'icon-accordion btn-accordion'+(this.state.expanded ? ' active' : '')}></span>
                }
                {
                  this.props.subbed &&
                  <div key="icon.subbed" className="tooltip" data-tooltip={this.props.subToolTip}><span className="icon-font icon-soccer-substitution-before"></span></div> || null
                }
                <span style={ { fontWeight:(this.props.onPitch ? 'bold' : 'normal') } } key="no" className="number">{ this.props.number || '-' }</span>
                <span key="name">
                  <span className="name" style={ { fontWeight:(this.props.onPitch ? 'bold' : 'normal') } }>{(this.props.name || '-')+', '+(this.props.position || '-')+' '}</span>
                  { aIcons }
                </span>
              </div>
              {
                this.state.expanded && this.props.wasActive && <ExpandedStats {...this.props} /> || null
              }
            </div>
          </td>
        </tr>
      )
    }
  }
}

class PlayersList extends React.Component {

  constructor( props ) {
    super(props)
    this.state = {
      combined :  true,
      homeAway :  'home'
    }
  }

  swapTeam( sTeam ) {
    this.setState( { homeAway:sTeam } )
  }
  
  render() {

    const home        = this.props.home || {}
    const away        = this.props.away || {}
    const matchState  = this.props.gameState || 'pregame'
    let bForceSplit   = this.props.split || false
    let bSplit        = this.state.split || false

    let aHomeStyle = { display: 'block' }
    let aAwayStyle = { display: 'block' }
    if ( !bSplit || !bForceSplit ) {
      if ( this.state.homeAway === 'home') {
        aAwayStyle = { display: 'none' }
      }else{
        aHomeStyle = { display: 'none' }
      }
    }

    return (
      <div id="gamepackage-game-lineups-expanded" data-module="lineups" data-sport="rugby">
        <article className={'boxscore-tabs sub-module-mobile-combine-split' + (this.state.combined ? ' combined' : '')} data-behavior="content_tab_mobile">
          <header>
            <div className="filter form-group button-group">
              <button className={'button-filter-alt lg fixed' + (this.state.homeAway === 'home' ? ' active' : '')} onClick={this.swapTeam.bind(this,'home')}>
                <span className="team-name">{home.name || '-'}</span>
                <span className="team-name-short">{home.name || '-'}</span>
              </button>
              <button className={'button-filter-alt lg fixed' + (this.state.homeAway === 'away' ? ' active' : '')} onClick={this.swapTeam.bind(this,'away')}>
                <span className="team-name">{away.name || '-'}</span>
                <span className="team-name-short">{away.name || '-'}</span>
              </button>
            </div>
          </header>
          <div className="row-wrapper">
            <div className="content-tab" style={aHomeStyle}>
              <div className="col column-one">
                <div className="sub-module rugby">
                  <div className="content">
                    <PlayerList {...home} text={this.props.text} matchState={matchState} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content-tab" style={aAwayStyle}>
              <div className="col column-two">
                <div className="sub-module rugby">
                  <div className="content">
                    <PlayerList {...away} text={this.props.text} matchState={matchState} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p style={ { fontSize:'11px',color:'#6c6d6f',padding:'12px' } }>{ selectn('props.text.note',this) }</p>
        </article>
      </div>
    )
  }
}

export default PlayersList



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/PlayersList.jsx